export function FileIcon2() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M11.6663 9.16663H6.66634M8.33301 12.5H6.66634M13.333 5.83329H6.66634M16.6663 5.66663V14.3333C16.6663 15.7334 16.6663 16.4335 16.3939 16.9683C16.1542 17.4387 15.7717 17.8211 15.3013 18.0608C14.7665 18.3333 14.0665 18.3333 12.6663 18.3333H7.33301C5.93288 18.3333 5.23281 18.3333 4.69803 18.0608C4.22763 17.8211 3.84517 17.4387 3.60549 16.9683C3.33301 16.4335 3.33301 15.7334 3.33301 14.3333V5.66663C3.33301 4.26649 3.33301 3.56643 3.60549 3.03165C3.84517 2.56124 4.22763 2.17879 4.69803 1.93911C5.23281 1.66663 5.93288 1.66663 7.33301 1.66663H12.6663C14.0665 1.66663 14.7665 1.66663 15.3013 1.93911C15.7717 2.17879 16.1542 2.56124 16.3939 3.03165C16.6663 3.56643 16.6663 4.26649 16.6663 5.66663Z"
        stroke="white"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
